import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
// import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from '@tanstack/react-query';

import { fetchAll, fetchOne } from '../../lib/v31lib';
import { loginAtom } from '../../lib/auth';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

import { ResponsiveContainer, Sankey, Tooltip, useChartWidth, Layer, Rectangle, SankeyNodeProps, SankeyLinkProps, TooltipContentProps } from 'recharts';
import { RechartsDevtools } from '@recharts/devtools';
import {
  ValueType,
  NameType,
} from 'recharts/types/component/DefaultTooltipContent';


import {
  Box,
  Button as Btn,
  ButtonGroup,
  CircularProgress,
  Divider,
  Grid,
} from '@mui/material';
import {
  ChevronLeft,
  ChevronRight
} from '@mui/icons-material';

import {
  Page,
  StyledButton,
  StyledDateField,
  StyledTextField,
  Typography
} from '../../components/interface';

import {
  BookYear
} from '../../models';

const { DateTime } = require("luxon");

type Props = {};
type RawExportStat = {
  custom_result: any
};

export const OperationsTransfersSankeyOutgoing: FunctionComponent<Props> = () => {
  // const navigate = useNavigate();
  const theme = useTheme();
  
  const [login, setLogin] = useAtom(loginAtom);
  const [statMode, setStatMode] = useState<string>("month");
  const [ageGroups, setAgeGroups] = useState<[number, number][]>([
    [0, 9], [10, 19], [20, 29],
    [30, 39], [40, 49], [50, 59],
    [60, 69], [70, 79], [80, 89],
    [90, 99], [100, 150]
  ]);
  const [perAge, setPerAge] = useState<boolean>(false);
  const [showTimeoutError, setShowTimeoutError] = useState<boolean>(false);
  const [activeMonth, setActiveMonth] = useState<string>(DateTime.now().toFormat("LL/yyyy"));
  const [dateFrom, setDateFrom] = useState<string>(DateTime.local(2019, 1, 1).toFormat("dd/LL/yyyy"));
  const [dateTo, setDateTo] = useState<string>(DateTime.now().toFormat("dd/LL/yyyy"));
  const [mainResult, setMainResult] = useState<any>();
  const [activeIteration, setActiveIteration] = useState<number>(0);
  const [showRawData, setShowRawData] = useState<boolean>(false);
  const [graphFocus, setGraphFocus] = useState<string>("money");
  const [ageFocusedLineData, setAgeFocusedLineData] = useState<any>();
  const [ageFocusedLineDataSold, setAgeFocusedLineDataSold] = useState<any>();
  const [amountFocusedBarData, setAmountFocusedBarData] = useState<any>();
  const [sanKeyData, setSanKeyData] = useState<any>();
  // const [colors14, setColors14] = useState<string[]>([ // months and quarters
  //   "#1B3A57", "#1F4E79", "#2E6F95", "#3F88A8", "#4DA3B3", 
  //   "#5FB9A6", "#7CCB8F", "#A4D86F", "#CDE05A", "#F0D64E", 
  //   "#F9B73C", "#F68B2C", "#E85D2A", "#D62828"
  // ]);
  // const [colors6, setColors6] = useState<string[]>([ // years
  //   "#1F4E79", "#3F88A8", "#7CCB8F", "#CDE05A", "#F9B73C", "#D62828"
  // ]);
  const [colors12, setColors12] = useState<string[]>([ // age groups
    "#2ECC71", "#58D68D", "#82E0AA", "#A9DFBF", "#F4D03F",
    "#F5B041", "#EB984E", "#DC7633", "#CA6F1E", "#A04000",
    "#5D6D7E", "#2C3E50"
  ]);
  const [colors12Grad, setColors12Grad] = useState<{source: string, target: string}[]>([]);
  const [sankeyHoverIndex, setSankeyHoverIndex] = useState<number>();
  const [ageKeys, setAgeKeys] = useState<string[]>([]);

  // const [colors120, setColors120] = useState<string[]>([ // ages
  //   "#2ECC71","#30CD72","#33CE73","#35CF74","#38D075","#3AD176","#3DD277","#3FD378","#42D479","#44D57A",
  //   "#47D67B","#49D77C","#4CD87D","#4EDA7F","#51DB80","#53DC81","#56DD82","#58DE83","#5BDF84","#5DE085",
  //   "#60E186","#63E287","#66E388","#69E489","#6CE58A","#6FE68B","#72E78C","#75E88D","#78E98E","#7BEA8F",
  //   "#7EEB90","#81EC91","#84ED92","#87EE93","#8AEF94","#8DF095","#90F196","#93F297","#96F398","#99F499",
  //   "#9CF59A","#A0F49A","#A4F299","#A8F098","#ACEE97","#B0EC96","#B4EA95","#B8E894","#BCE693","#C0E492",
  //   "#C4E291","#C8E090","#CCDE8F","#D0DC8E","#D4DA8D","#D8D88C","#DCD68B","#E0D48A","#E4D289","#E8D088",
  //   "#ECD087","#EFCB84","#F2C681","#F5C17E","#F8BC7B","#FBB778","#FDB275","#F8AD72","#F3A86F","#EEA36C",
  //   "#E99E69","#E49966","#DF9463","#DA8F60","#D58A5D","#D0855A","#CB8057","#C67B54","#C17651","#BC714E",
  //   "#B76C4B","#B26748","#AD6245","#A85D42","#A3583F","#9E533C","#994E39","#944936","#8F4433","#8A3F30",
  //   "#853A2D","#80352A","#7B3027","#762B24","#712621","#6C211E","#671C1B","#621718","#5D1215","#580D12",
  //   "#560F1A","#541122","#52132A","#501532","#4E173A","#4C1942","#4A1B4A","#481D52","#461F5A","#442162",
  //   "#42236A","#402572","#3E277A","#3C2982","#3A2B8A","#382D92","#362F9A","#3431A2","#3233AA","#2C3E50"
  // ]);
  const [hiddenDataPoints, setHiddenDataPoints] = useState<string[]>([]);

  // const {
  //   data: bookYears,
  //   // isLoading: bookYearsLoading,
  //   // isError: bookYearsError,
  //   // isSuccess: bookYearsSuccess,
  //   // refetch: bookYearsRefetch,
  // } = useQuery({
  //   queryKey: ["book_years"],
  //   queryFn: () =>
  //     fetchAll<BookYear>(
  //       "/nl/v3/objects/fetch_all",
  //       {
  //         object: "book_year",
  //         fields: ["id", "short_visual"],
  //         order: "id DESC"
  //       },
  //       login
  //     ),
  //   enabled: !!login
  // });










  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetchOne<{
        custom_result: any
      }>(
        '/nl/v3/objects/custom_action',
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      mutationCustomAction.reset();
      setShowTimeoutError(true);
      return true;
    },
    onSuccess: (data, variables, context) => {
      setMainResult(data.custom_result);
    },
  });







  function MyCustomSankeyLink({ sourceX, targetX, sourceY, targetY, sourceControlX, targetControlX, linkWidth, index }: SankeyLinkProps) {
    const gradientID = `linkGradient${index}`;
    return (
      <Layer key={`CustomLink${index}`}>
        <defs>
          <linearGradient id={gradientID}>
            <stop offset="20%" stopColor={colors12Grad[index].source} stopOpacity={0.5} />
            <stop offset="80%" stopColor={colors12Grad[index].target} stopOpacity={0.5} />
          </linearGradient>
        </defs>
        <path
          d={`
            M${sourceX},${sourceY + linkWidth / 2}
            C${sourceControlX},${sourceY + linkWidth / 2}
              ${targetControlX},${targetY + linkWidth / 2}
              ${targetX},${targetY + linkWidth / 2}
            L${targetX},${targetY - linkWidth / 2}
            C${targetControlX},${targetY - linkWidth / 2}
              ${sourceControlX},${sourceY - linkWidth / 2}
              ${sourceX},${sourceY - linkWidth / 2}
            Z
          `}
          fill={sankeyHoverIndex === index ? "rgba(0, 136, 254, 0.8)" : `url(#${gradientID})`}
          strokeWidth="0"
          onMouseEnter={(a) => {
            setSankeyHoverIndex(index);
            // this.setState({ fill: "rgba(0, 136, 254, 0.5)" });
          }}
          onMouseLeave={() => {
            setSankeyHoverIndex(undefined);
            // this.setState({ fill: "url(#linkGradient)" });
          }}
        />
      </Layer>
    );
  };
  function MyCustomSankeyNode({ x, y, width, height, index, payload }: SankeyNodeProps) {
    const containerWidth = useChartWidth();
    if (containerWidth == null) {
      return null; // Return null if used outside a chart context
    }
    const isOut = x + width + 6 > containerWidth;
    // console.log(index, payload);
    // console.log(ageKeys, (ageKeys.indexOf(payload.name.replace("T ", "").replace("R ", ""))));

    let extra = 0;
    if (!!isOut) payload.sourceLinks.forEach(iii => extra += sanKeyData.links[iii].extra);
    if (!isOut) payload.targetLinks.forEach(iii => extra += sanKeyData.links[iii].extra);

    let doHide = !payload.value;

    let labelKeys = [];
    labelKeys.push(payload.name.replace("T ", "").replace("R ", ""));
    labelKeys.push(`${payload.value.toLocaleString('nl')}${graphFocus === 'individuals' ? "" : " EUR"}`);
    labelKeys.push(`${extra?.toLocaleString('nl')}${graphFocus === 'individuals' ? " EUR" : ""}`);
    if (!!isOut) labelKeys = labelKeys.reverse();

    return (
      <Layer key={`CustomNode${index}`} style={!!doHide ? {display: 'none'} : {}}>
        <Rectangle
          x={x}
          y={y}
          width={width}
          height={height}
          // fill="#5192ca"
          fill={colors12[(ageKeys.indexOf(payload.name.replace("T ", "").replace("R ", ""))) % colors12.length]}
          fillOpacity="1"
        />
        <text
          textAnchor={isOut ? 'end' : 'start'}
          x={isOut ? x - 6 : x + width + 6}
          // y={y + height / 2}
          y={y + height / 2 + 4}
          fontSize="13"
          stroke="#333"
        >
          {labelKeys.join(" / ")}
        </text>
      </Layer>
    );
  }
  const CustomTooltip = ({
    active,
    payload,
    label,
}: TooltipContentProps<ValueType, NameType>) => {
    if (active && payload && payload.length) {
// console.log(payload);

      let trans = payload[0]?.payload?.payload?.extra;
      if (!!payload[0]?.payload?.payload?.name) {
        // console.log(payload[0]?.payload?.payload);
        trans = 0;
        // @ts-ignore
        if (payload[0]?.payload?.payload?.name[0] === "T") payload[0]?.payload?.payload?.targetLinks.forEach(iii => trans += sanKeyData.links[iii].extra);
        // @ts-ignore
        if (payload[0]?.payload?.payload?.name[0] !== "T") payload[0]?.payload?.payload?.sourceLinks.forEach(iii => trans += sanKeyData.links[iii].extra);
      }

      return (
        <Box className="custom-tooltip" sx={{backgroundColor: 'white', padding: 1, borderRadius: 2, paddingTop: 1, border: '1px solid transparent', borderColor: theme.palette.tertiary?.main}}>
          {!!payload[0]?.payload?.payload?.source && <>
            {/* @ts-ignore */}
            <Typography>{`From: ${payload[0]?.payload?.payload?.source?.name.replace("T ", "").replace("R ", "")}`}</Typography>
            {/* @ts-ignore */}
            <Typography>{`To: ${payload[0]?.payload?.payload?.target?.name.replace("T ", "").replace("R ", "")}`}</Typography>
          </>}
          {!!payload[0]?.payload?.payload?.name && <>
            {/* @ts-ignore */}
            <Typography>{`${payload[0]?.payload?.payload?.name[0] === "T" ? "From" : "To"}: ${payload[0]?.payload?.payload?.name.replace("T ", "").replace("R ", "")}`}</Typography>
          </>}
          {/* @ts-ignore */}
          <Typography>{`${graphFocus === 'individuals' ? "Transactions" : "Amount"}: ${payload[0]?.payload?.value?.toLocaleString('nl')}${graphFocus === 'individuals' ? "" : " EUR"}`}</Typography>
          {/* @ts-ignore */}
          <Typography>{`${graphFocus === 'individuals' ? "Amount" : "Transactions"}: ${trans?.toLocaleString('nl')}${graphFocus === 'individuals' ? " EUR" : ""}`}</Typography>
        </Box>
      );
    }
  };







  useEffect(() => {
    if (!!mainResult) {
      // console.log(mainResult.ages);
      let nodes:string[] = [];
      let result:any = {
        nodes: [],
        links: [
          // { source: 0, target: 2, value: 3728.3 },
          // { source: 0, target: 3, value: 354170 },
          // { source: 1, target: 2, value: 62429 },
          // { source: 1, target: 3, value: 291741 },
        ]
      };

      if (graphFocus === 'money') {
        Object.keys(mainResult.left_years?.sum).forEach(group_key => {
          let id_left = -1;
          let id_right = -1;
  
          let age_give = group_key;
          let age_give_slot = mainResult.groups[group_key];
        });






        Object.keys(mainResult.groups).forEach(group_key => {
          let id_left = -1;
          let id_right = -1;
  
          let age_give = group_key;
          let age_give_slot = mainResult.groups[group_key];
  
          // @ts-ignore
          if (Object.values(age_give_slot).filter(fff => fff.amount > 0).length > 0) {
            id_left = nodes.indexOf(`T ${age_give}`);
            if (id_left < 0) {
              result.nodes.push({name: `T ${age_give}`});
              nodes.push(`T ${age_give}`);
              id_left = nodes.indexOf(`T ${age_give}`);
            }
  
            if (!!age_give_slot) {
              Object.keys(age_give_slot).forEach(get_key => {
                // console.log(age_get_slot);
  
                let age_get = get_key;
                let age_get_slot = mainResult.groups[group_key][get_key];
  
                id_right = nodes.indexOf(`R ${age_get}`);
                if (id_right < 0) {
                  result.nodes.push({name: `R ${age_get}`});
                  nodes.push(`R ${age_get}`);
                  id_right = nodes.indexOf(`R ${age_get}`);
                }
  
                if (!!age_get_slot && !!age_get_slot.amount) {
                  result.links.push({source: id_left, target: id_right, value: age_get_slot.amount, extra: age_get_slot.count});
                }
              });
            }
          }
        });
      }
      if (graphFocus === 'individuals') {
        Object.keys(mainResult.groups).forEach(group_key => {
          let id_left = -1;
          let id_right = -1;
  
          let age_give = group_key;
          let age_give_slot = mainResult.groups[group_key];
  
          // @ts-ignore
          if (Object.values(age_give_slot).filter(fff => fff.count > 0).length > 0) {
            id_left = nodes.indexOf(`T ${age_give}`);
            if (id_left < 0) {
              result.nodes.push({name: `T ${age_give}`});
              nodes.push(`T ${age_give}`);
              id_left = nodes.indexOf(`T ${age_give}`);
            }
  
            if (!!age_give_slot) {
              Object.keys(age_give_slot).forEach(get_key => {
                // console.log(age_get_slot);
  
                let age_get = get_key;
                let age_get_slot = mainResult.groups[group_key][get_key];
  
                id_right = nodes.indexOf(`R ${age_get}`);
                if (id_right < 0) {
                  result.nodes.push({name: `R ${age_get}`});
                  nodes.push(`R ${age_get}`);
                  id_right = nodes.indexOf(`R ${age_get}`);
                }
  
                if (!!age_get_slot && !!age_get_slot.count) {
                  result.links.push({source: id_left, target: id_right, value: age_get_slot.count, extra: age_get_slot.amount});
                }
              });
            }
          }
        });
      }

      // console.log(result);
      setSanKeyData(result);

      let ageKeyTemp:string[] = [];
      ageGroups.map((ag) => {
        ageKeyTemp.push([ag[0], ag[1]].join("-"));
      });
      setAgeKeys(ageKeyTemp);

      //@ts-ignore
      const colorGradients = result.links.map((link) => {
        return {
          source: colors12[(ageKeyTemp.indexOf((nodes[link.source]).replace("T ", "").replace("R ", ""))) % 12],
          target: colors12[(ageKeyTemp.indexOf((nodes[link.target]).replace("T ", "").replace("R ", ""))) % 12]
        };
      });
      setColors12Grad(colorGradients);

    }
  }, [mainResult, perAge, hiddenDataPoints, graphFocus]);











  return <Page sx={{}} title="Operation // Transfers // Outgoing Sankey" helper="operations">
    <Grid container spacing="8" sx={{
      "& .bar_T": {
        // opacity: 0.6
      }
    }}>
      {/* <Grid item xs={12}>
        <Typography variant="caption">Data interval</Typography>
      </Grid>
      <Grid item xs={12}>
        <ButtonGroup variant="outlined">
          <Btn variant={statMode === "month" ? "contained" : "outlined"} onClick={() => {setStatMode("month");}}>Monthly</Btn>
          <Btn variant={statMode === "quarter" ? "contained" : "outlined"} onClick={() => {setStatMode("quarter");}}>Quarterly</Btn>
          <Btn variant={statMode === "year" ? "contained" : "outlined"} onClick={() => {setStatMode("year");}}>Yearly</Btn>
        </ButtonGroup>
      </Grid> */}
      <Grid item xs={12}>
        <Typography variant="caption">Data interval</Typography>
      </Grid>
      <Grid item xs={6}>
        <StyledDateField
          label="From"
          value={dateFrom || ''}
          id='cr_from'
          onChange={(v) => {
            setDateFrom(v.toString());
          }}
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <StyledDateField
          label="To"
          value={dateTo || ''}
          id='cr_to'
          onChange={(v) => {
            setDateTo(v.toString());
          }}
          fullWidth
        />
      </Grid>
      <Grid item container xs={12} spacing="8">
        <Grid item xs={12}>
          <Typography variant="caption">Age groups</Typography>
        </Grid>
        {ageGroups.map((age, i) => <Grid item container xs={2} spacing="8">
          <Grid item xs={5}>
            <StyledTextField
              label="Start ["
              value={age[0].toString()}
              id='start_x'
              onChange={(v) => {
                let newAgeGroups = [...ageGroups];
                newAgeGroups[i][0] = parseInt(v, 10);
                setAgeGroups(newAgeGroups);
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={5} sx={{position: 'relative'}}>
            <StyledTextField
              label="End ]"
              value={age[1].toString()}
              id='end_x'
              onChange={(v) => {
                let newAgeGroups = [...ageGroups];
                newAgeGroups[i][1] = parseInt(v, 10);
                setAgeGroups(newAgeGroups);
              }}
              fullWidth
            />
            <RemoveCircleIcon sx={{color: theme.palette.secondary.main, position: 'absolute', top: 0, right: -16, cursor: 'pointer'}} onClick={() => {
              let newAgeGroups: [number, number][] = [];
              ageGroups.forEach((ag, ii) => {
                if (ii !== i) newAgeGroups.push(ag);
              });
              setAgeGroups(newAgeGroups);
            }} />
          </Grid>
        </Grid>)}
        <Grid item xs={2} container spacing="8">
          <Grid item xs={10} sx={{textAlign: 'center'}}>
            <AddCircleOutlineIcon sx={{color: theme.palette.tertiary?.main, marginTop: 1.5, cursor: 'pointer'}} onClick={() => {
              setAgeGroups([...ageGroups, [0, 0]]);
            }} />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sx={{marginTop: 2}}>
        <StyledButton
          label="Fetch"
          id='fetch'
          contained
          loading={mutationCustomAction.isPending}
          onClick={(v) => {
            setShowTimeoutError(false);
            setSanKeyData(undefined);
            
            mutationCustomAction.mutate({
              formData: {
                object: 'operations',
                class_action: 'custom_api_operations_transfers_to_exits_sankey',
                stat_mode: statMode,
                age_groups: ageGroups,
                per_age: (perAge ? 1 : 0),
                date_from: dateFrom,
                date_to: dateTo
              }
            });
          }}
          sx={{
            marginRight: 1
          }}
        />
      </Grid>
      {!!showTimeoutError && <Grid item xs={12}>
        <Typography sx={{
          padding: 2,
          border: '1px solid transparent',
          borderColor: theme.palette.secondary.main,
          backgroundColor: theme.palette.opacitated?.secondary_02
        }}>A timeout happened. If it took about a minute for this message to show, the cache is building. Try again in 2-3 minutes.<br />If this did not take about a minute, contact IT!</Typography>
      </Grid>}




      {!!mainResult && <>
        <Grid item xs={12}><Divider /></Grid>
        <Grid item xs={4}>
          <Typography variant="caption">Data visualisation</Typography><br/>
          <ButtonGroup variant="outlined">
            <Btn variant={!!showRawData ? "contained" : "outlined"} onClick={() => {setShowRawData(true);}}>Raw data</Btn>
            <Btn variant={!showRawData ? "contained" : "outlined"} onClick={() => {setShowRawData(false);}}>Graphs</Btn>
          </ButtonGroup>
        </Grid>

        {!showRawData && <>
          <Grid item xs={4} sx={{display: 'none'}}>
            <Typography variant="caption">Age split</Typography><br/>
            <ButtonGroup variant="outlined">
              <Btn variant={!!perAge ? "contained" : "outlined"} onClick={() => {setPerAge(!perAge);}}>Per Age</Btn>
              <Btn variant={!perAge ? "contained" : "outlined"} onClick={() => {setPerAge(!perAge);}}>Age Groups</Btn>
            </ButtonGroup>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="caption">Sankey focus</Typography><br/>
            <ButtonGroup variant="outlined">
              <Btn variant={graphFocus === 'money' ? "contained" : "outlined"} onClick={() => {setGraphFocus("money");}}>Amount</Btn>
              <Btn variant={graphFocus === 'individuals' ? "contained" : "outlined"} onClick={() => {setGraphFocus("individuals");}}>Transactions</Btn>
            </ButtonGroup>
          </Grid>
          <Grid item xs={12}>
            &nbsp;
          </Grid>

          <ResponsiveContainer width="100%" height={1000}>
            <Sankey
              data={sanKeyData}
              node={MyCustomSankeyNode}
              nodePadding={2}
              iterations={0}
              margin={{
                bottom: 10,
              }}
              link={MyCustomSankeyLink}
              // link={{ stroke: '#77c878' }}
            >
              {/* <Tooltip /> */}
              {/* @ts-ignore */}
              <Tooltip content={<CustomTooltip />} />
              <RechartsDevtools />
            </Sankey>
          </ResponsiveContainer>
        </>}








        {/* {!!showRawData && <>
          <Grid item xs={12}><Divider /></Grid>

          <Grid item xs={3} sx={{textAlign: 'right'}}><Typography sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Age Bought</Typography></Grid>
          <Grid item xs={3} sx={{textAlign: 'right'}}><Typography sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Age Sold</Typography></Grid>
          <Grid item xs={3} sx={{textAlign: 'right'}}><Typography sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Amount</Typography></Grid>
          <Grid item xs={3} sx={{textAlign: 'right'}}><Typography sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Transactions</Typography></Grid>

          {Array.from(Array(120), (_, i) => i).map((_, age) => <>
            {Array.from(Array(120), (_, i) => i).map((_, age_sold) => <>
              {!!mainResult.ages[age] && mainResult.ages[age][age_sold] && <>
                <Grid item xs={3} sx={{textAlign: 'right'}}>
                  <Typography>{age}</Typography>
                </Grid>
                <Grid item xs={3} sx={{textAlign: 'right'}}>
                  <Typography>{age_sold}</Typography>
                </Grid>
                <Grid item xs={3} sx={{textAlign: 'right'}}>
                  <Typography>{!!mainResult.ages[age] && mainResult.ages[age][age_sold] ? mainResult.ages[age][age_sold].amount.toLocaleString("nl-BE", {style: "currency", currency: "EUR", maximumFractionDigits: 0}) : ''}</Typography>
                </Grid>
                <Grid item xs={3} sx={{textAlign: 'right'}}>
                  <Typography>{!!mainResult.ages[age] && mainResult.ages[age][age_sold] ? mainResult.ages[age][age_sold].count : 0}</Typography>
                </Grid>
              </>}
            </>)}
          </>)}
        </>} */}
      </>}
    </Grid>
  </Page>;
}
